import React, { useEffect } from 'react'
import { InputValidators } from '../../utils/InputValidators';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { FiAlertTriangle, FiSave, FiSlash } from 'react-icons/fi';
import { editBrand, newBrand } from '../../app/store/catalogs/thunk';
import Swal from 'sweetalert2';

export const M_Brands = ({ selectedItem, setSelectedItem, onClose }) => {

  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
  const dispatch = useDispatch();

  // Cuando cambia selectedItem, actualizar los campos del formulario
  useEffect(() => {
    if (selectedItem) {
      setValue("nombreMarca", selectedItem.NAMEBRAND);
      setValue("descripcionMarca", selectedItem.DESCRIPTIONS);
    } else {
      reset();
    }
  }, [selectedItem, setValue, reset]);

  const save = (data) => {
    // console.log("Datos guardados:", data);
    if (selectedItem) {
      Swal.fire({
        title: 'Atención',
        text: "Está por modficiar una Marca, ¿Desea de continuar con esta acción?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3b7ddd',
        cancelButtonColor: '#dc3545',
        cancelButtonText: 'No',
        confirmButtonText: 'Si'
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(editBrand(data, selectedItem.ID));
          onClose(); // cerrar modal al guardar
          reset();
        }
      })
    }
    else {
      Swal.fire({
        title: 'Atención',
        text: "Está por registar una Nueva Marca, ¿Desea de continuar con esta acción?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3b7ddd',
        cancelButtonColor: '#dc3545',
        cancelButtonText: 'No',
        confirmButtonText: 'Si'
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log(data);
          dispatch(newBrand(data));
          onClose(); // cerrar modal al guardar
          reset();
        }
      })
    }


  };





  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content" style={{ backgroundColor: '#ffffff' }}>
          <div className="modal-header">
            <h5 className="modal-title fw-bold">
              {selectedItem ? `Edición de Marca: ${selectedItem.NAMEBRAND}` : "Nueva Marca"}
            </h5>
            <button type="button" className="btn-close" onClick={() => { reset(); onClose(); }}></button>
          </div>

          <form onSubmit={handleSubmit(save)}>
            <div className="modal-body">
              {selectedItem && (
                <div className="alert alert-warning">
                  <strong>Atención:</strong> Está modificando la información de una categoría.
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">Nombre:</label>
                <input type="text" className="form-control" autoComplete='off' {...register("nombreMarca", { required: 'Nombre de la Marca es requerido', minLength: { value: 2, message: 'Debe tener mínimo 2 caracteres' } })}
                  onKeyDown={InputValidators.validateAlphanumeric} />
                {errors.nombreMarca && (
                  <div className='text-danger fw-bold mt-1'>
                    <FiAlertTriangle size="22" /> {errors.nombreMarca.message}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Descripción:</label>
                <textarea className="form-control" rows="5" {...register("descripcionMarca", { required: 'La descripcion es requerida' })}
                  onKeyDown={InputValidators.validateAlphanumeric}></textarea>
                {errors.descripcionMarca && (
                  <div className='text-danger fw-bold mt-1'>
                    <FiAlertTriangle size="16" /> {errors.descripcionMarca.message}
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-outline-danger" onClick={() => { reset(); onClose(); }}>
                <FiSlash size={16} /> Cancelar
              </button>
              <button type="submit" className="btn btn-outline-primary">
                <FiSave size={16} /> Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
